import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from 'components/shared/modal/FormModal';
import { getCurrentWorkOrder } from 'selectors/admin/work-orders/work-orders';
import './ClientStreamModal.css';
import {
  getShowClientStreamModal,
  getWorkOrderNotes,
} from 'selectors/admin/work-orders/details/details';
import {
  addWorkOrderNoteRequest,
  loadWorkOrderNotesRequest,
  setShowClientStreamModal,
} from 'actions/admin/work-orders/details/details';
import Chat from 'components/shared/chat/Chat';

class ClientStreamModal extends Component {
  handleLoadNotes = () => {
    return this.props.dispatch(
      loadWorkOrderNotesRequest(this.props.currentWorkOrder.id)
    );
  };

  handleAddNote = (note) => {
    return this.props.dispatch(
      addWorkOrderNoteRequest(this.props.currentWorkOrder.id, note)
    );
  };

  handleClose = () => {
    this.props.dispatch(setShowClientStreamModal(false));
  };

  static getWorkOrderName(workOrder) {
    return workOrder.name !== null ? `: ${workOrder.name}` : '';
  }

  render() {
    return this.props.showClientStreamModal ? (
      <FormModal
        className="client-stream-modal"
        show={this.props.showClientStreamModal}
        title={`Stream / WO #${
          this.props.currentWorkOrder.number
        }${ClientStreamModal.getWorkOrderName(this.props.currentWorkOrder)}`}
        onClose={this.handleClose}
      >
        <div>
          <Chat
            notes={this.props.workOrderNotes}
            loadChat={this.handleLoadNotes}
            handleSubmit={this.handleAddNote}
          />
        </div>
      </FormModal>
    ) : null;
  }
}

export default connect((state) => {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    showClientStreamModal: getShowClientStreamModal(state),
    workOrderNotes: getWorkOrderNotes(state),
  };
})(ClientStreamModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/ClientStreamModal.js